import React, { useEffect, createContext, useState, useRef } from 'react'

import MenuAccessibility from './_accessibility'
import useOnClickOutside from '../../../utils/hooks/useOnClickOutside'
import useLockBodyScroll from '../../../utils/hooks/useLockBodyScroll'

export const NavContext = createContext()

const Nav = (props) => {
  const isBrowser = typeof window !== 'undefined'
  const navRef = useRef(null)
  const [isSubOpen, setIsSubOpen] = useState(false)
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const [isActiveSub, setActiveSub] = useState(null)
  const mobileNav = props.mobileNav ? props.mobileNav : 'hamburger'

  useEffect(() => {
    const onResize = () => {
      if (isMobileOpen === false && !props.scrollLock) {
        document.body.style.overflow = 'visible'
        document.body.classList.remove('body-locked')
      }
    }
    onResize()
    if (isBrowser) {
      window.addEventListener('resize', onResize)
    }
    MenuAccessibility(navRef.current)
  })

  // Lock Body scroll when mobile nav is opened
  useEffect(() => {
    if (!props.scrollLock) {
      if (isMobileOpen === true) {
        useLockBodyScroll(navRef.current, true)
      } else {
        useLockBodyScroll(null, true)
      }
    }
  }, [isMobileOpen])

  // Close Subnav when clicking outside
  function closeNav() {
    setActiveSub(null)
    setIsMobileOpen(false)
    setIsSubOpen(false)
  }
  useOnClickOutside(navRef, () => closeNav())

  // Add props for menu elements
  const childrenWithProps = React.Children.map(props.children, child => {
    return React.cloneElement(child, {
      tabIndex: '0',
      disableAutoActive: props.disableAutoActive ? true : false
    })
  })

  // Toggle Mobile Nav
  const mobileClickEvent = e => {
    setIsMobileOpen(!isMobileOpen)
    setIsSubOpen(!isSubOpen)
  }

  return (
    <NavContext.Provider value={{ subOpen: [isSubOpen, setIsSubOpen], activeSub: [isActiveSub, setActiveSub], mobileOpen: [isMobileOpen, setIsMobileOpen] }}>
      <nav
        className={`${props.className ? props.className : ''} ${isSubOpen ? 'open' : ''} ${isMobileOpen ? 'mobile-open' : ''} ${props.mobileNav ? `nav-mobile-${props.mobileNav}` : ''}`}
        aria-label={props.name}
        role="navigation"
        ref={navRef}
      >
        <ul
          className={`nav-list`}
          aria-label={props.name}
          role="menubar"
          id="main-menu"
          aria-expanded={isSubOpen}
        >
          {childrenWithProps}
        </ul>
        {mobileNav === 'hamburger' && (
          <button
            className={`nav-hamburger`}
            onClick={mobileClickEvent}
            aria-expanded={isMobileOpen}
            aria-label={`${props.name} Button`}
            aria-controls="main-menu"
          >
            <div className="nav-hamburger-inner"></div>
          </button>
        )}
      </nav>
    </NavContext.Provider>
  )
}
export default Nav